export default "__VITE_ASSET__DHPxIEQr__$_?url__"